@if (mode === 'dropdown') {
  <select
    [class]="computedClasses"
    [value]="value"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    (change)="onChange($event)">
    @if (placeholder) {
      <option value="" disabled [selected]="value === ''">{{ placeholder }}</option>
    }
    @for (option of options; track option.value) {
      <option
        [value]="option.value"
        [disabled]="option.disabled || false"
        [selected]="option.value === value">
        {{ option.label }}
      </option>
    }
  </select>
} @else {
  <!-- Button group mode -->
  <div [class]="buttonGroupContainerClasses" role="group" [attr.aria-label]="ariaLabel || 'Button group selection'">
    @for (option of options; track option.value) {
      <input
        type="radio"
        class="btn-check"
        [name]="groupName"
        [id]="groupName + '_' + option.value"
        [value]="option.value"
        [checked]="option.value === value"
        [disabled]="option.disabled || disabled"
        (change)="onRadioChange(option.value)"
        autocomplete="off">
      <label
        [class]="buttonClasses"
        [for]="groupName + '_' + option.value"
        [class.opacity-50]="option.disabled || disabled">
        {{ option.label }}
      </label>
    }
  </div>
}
